import { render, staticRenderFns } from "./VendorChargeTiers.vue?vue&type=template&id=15074c7a&scoped=true"
import script from "./VendorChargeTiers.vue?vue&type=script&lang=js"
export * from "./VendorChargeTiers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15074c7a",
  null
  
)

export default component.exports